<template>
  <div class="dashboard-layout background mr-4 mr-md-0">
    <v-banner v-if="moreThanThreeLoan >= 3" sticky class="green white--text">
      <div class="py-1 px-md-15 d-flex flex-column flex-md-row justify-space-between align-center">
        <p class="hidden-md-and-down"></p>
        <p class="mb-0 text-body-2 text-md-body-1 listStyle">
          Some loan applications are moving to
          <strong class="brand-text">Century Financial Services</strong>.
          A faster, more secure system with enhanced features coming soon.
        </p>
        <v-btn v-if="!didReadMigrateNotice" @click="dialog = true" color="primary" small
          class="mt-2 mt-md-0 ml-md-4 px-4" depressed aria-label="Learn more about Century Financial Services">
          Learn More
        </v-btn>
        <span v-else class="mt-2 mt-md-0 ml-md-4" style="width: 115px; height: 36px;"></span>
      </div>
    </v-banner>

    <v-dialog v-model="dialog" persistent max-width="600px" max-height="90vh" transition="dialog-bottom-transition">
      <v-card class="pa-4 pa-md-6"
        style="border-radius: 12px; overflow-y: auto; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);">
        <!-- Close button -->
        <v-btn icon small class="close-btn hidden-md-and-down" @click="dialog = false" aria-label="Close dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- Card Title -->
        <v-card-title class="text-md-h5 font-weight-bold primary--text pb-4 textStyle">
          A New Chapter in Lending
        </v-card-title>

        <!-- Card Content -->
        <v-card-text class="text-body-1 text-md-body-1">
          <p class="mb-4 textStyle">
            Some loan applications are moving soon to
            <strong class="brand-text">Century Financial Services</strong>.
            Experience a fresh, faster, and more secure system designed to elevate your borrowing journey.
          </p>
          <p class="mb-4 textStyle">
            In the coming months, you’ll unlock enhanced features with <strong class="brand-text">Century Financial
              Services</strong>, including:
          </p>
          <v-list class="feature-list pa-0">
            <v-list-item v-for="(feature, index) in features" :key="index" class="py-1">
              <v-list-item-icon class="mr-4">
                <v-icon color="primary">{{ feature.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-body-1 text-wrap listStyle" v-html="feature.text" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <p class="mt-6 textStyle">
            <strong class="primary--text">But for now, nothing changes!</strong><br />
            You’ll be seamlessly redirected when it’s time to apply through
            <strong class="brand-text">Century Financial Services</strong>. The transition will be smooth and
            effortless.
          </p>
        </v-card-text>

        <!-- Card Actions -->
        <v-card-actions class="pt-4">
          <v-spacer />
          <v-btn color="primary" large depressed class="px-6 textStyle" @click="dismissDialog">
            Got it
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <the-header class="mr-n4 mr-md-0" />

    <v-main>
      <v-container class="pa-0 mt-md-8">
        <v-row>
          <!-- Sidebar -->
          <v-col class="hidden-md-and-down" cols="12" lg="3">
            <Sidebar />
          </v-col>

          <!-- Main -->
          <v-col class="mr-n4 mr-md-0" cols="12" lg="9">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
      <!-- <v-dialog v-model="dialog" persistent max-width="90vw" max-height="90vh">
        <v-card class="pa-4" style="max-height: 100%; overflow-y: auto;">
          <v-card-title class="headline text-h6 text-md-h5">
            A New Chapter in Lending
          </v-card-title>
          <v-card-text class="text-body-2 text-md-body-1">
            <p>
              Some loan applications are moving soon to
              <strong style="color: #08338F;">Century Financial Services</strong>. A fresh, faster, and
              more secure system to improve your borrowing experience.
              In the coming months, you’ll enjoy enhanced features in Century
              Financial Services like:
            </p>
            <ul>
              <li>
                💳 Card payments directly from your profile via
                <strong>Peach Payments</strong>
              </li>
              <li>
                ⚡ Real-time payouts using <strong>PayShap</strong> and your
                <strong>ShapID</strong>
              </li>
              <li>📱 Mobile wallet disbursements for even more convenience</li>
            </ul>
            <br />
            <p>
              <strong class="primary--text">But for now, nothing changes!</strong><br />
              You will be redirected when it’s time to apply through <span style="color: #08338F;"><strong>Century
                  Financial
                  Services</strong></span>. The switch will be easy and seamless.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dismissDialog">Got it</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-main>

    <the-footer class="mr-n4 mr-md-0" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import TheHeader from "@/components/shared/headers/TheHeader";
import Sidebar from "@/components/dashboard/pages/Sidebar";
import TheFooter from "@/components/shared/footers/TheFooter";

export default {
  name: "LimeLoansDashboard",
  components: { TheHeader, Sidebar, TheFooter },
  props: {
    value: Boolean,
  },

  data() {
    return {
      dialog: false,
      didReadMigrateNotice: false,
      moreThanThreeLoan: 0,
    };
  },

  computed: {
    ...mapState({ auth: "auth" }),
    features() {
      return [
        {
          icon: 'mdi-credit-card-outline',
          text: 'Card payments directly from your profile via <strong>Peach Payments</strong>',
        },
        {
          icon: 'mdi-lightning-bolt',
          text: 'Real-time payouts using <strong>PayShap</strong> and your <strong>ShapID</strong>',
        },
        {
          icon: 'mdi-cellphone',
          text: 'Mobile wallet disbursements for added convenience',
        },
      ];
    },
  },

  created() {
    this.setMigrationNoticeDialog();

    if (
      this.auth &&
      this.auth.user &&
      this.auth.user.banking_details &&
      this.auth.user.banking_details.bank_name &&
      this.auth.user.banking_details.account_number &&
      this.auth.user.banking_details.bank_name == "Standard Bank" &&
      this.auth.user.banking_details.account_number == "123456789"
    ) {
      //
    } else if (!this.auth.user.has_banking || !this.auth.user.has_next_of_kin) {
      this.$router.push({ name: "RegistrationPage" });
    }
  },

  mounted() { },

  watch: {
    "auth.idnumber"() {
      this.setMigrationNoticeDialog();
    }
  },

  methods: {
    setMigrationNoticeDialog() {
      const user = this.$store.getters["auth/getUser"];
      const getIdNumber = this.auth.idnumber;

      if (getIdNumber) {
        this.moreThanThreeLoan = user.previous_active_loan_count || 0;

        this.didReadMigrateNotice = localStorage.getItem(`didReadMigrateNotice_${getIdNumber}`) === "true";

        // setInterval(() => {
        // Show dialog if they haven't read the notice and had 3+ loans
        // this.dialog = this.moreThanThreeLoan >= 3 && !this.didReadMigrateNotice;
        // }, 1000);
      }
    },

    dismissDialog() {
      this.didReadMigrateNotice = true;
      this.dialog = false;
      const id = this.auth.idnumber;
      localStorage.setItem(`didReadMigrateNotice_${id}`, "true");
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-layout {
  min-height: 100%;
}

.banner {
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
  background: linear-gradient(145deg, #2e7d32, #388e3c);
}

.banner-content {
  padding: 12px 16px;
}

.textStyle {
  font-family: "Raleway", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.listStyle {
  font-family: "Raleway", sans-serif;
  font-style: normal;
  font-weight: 300;
  // font-size: 16px;
}

.primary-text {
  color: #08338F !important;
}

.brand-text {
  color: #08338F !important;
  font-weight: 700;
  font-family: "Raleway", sans-serif;
}

.feature-list .v-list-item {
  transition: transform 0.2s ease-in-out;
}

.feature-list .v-list-item:hover {
  transform: translateX(8px);
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
}

.v-card {
  background: linear-gradient(145deg, #ffffff, #f9fafb);
}

.v-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}

@media (max-width: 600px) {
  .banner-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
  }

  .v-btn {
    width: 100%;
    justify-content: center;
  }

  .textStyle {
    font-size: 14px !important;
    line-height: 18px !important;
  }

  .v-card-title {
    font-size: 1.25rem !important;
  }

  .v-card-text {
    font-size: 0.875rem !important;
  }
}
</style>
